// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import VueCookies from 'vue-cookies';
import VueLazyload from 'vue-lazyload';
import Vue2TouchEvents from 'vue2-touch-events';
import router from './router';
import store from './store/index';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-client';
import {HttpLink} from 'apollo-link-http';
import {ApolloLink} from 'apollo-link';
import {InMemoryCache, IntrospectionFragmentMatcher} from 'apollo-cache-inmemory';
import introspectionQueryResultData from './apollo/fragmentTypes.json';
import { i18n } from './plugins/i18n.js';
import VueMatomo from 'vue-matomo';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

const httpLink = new HttpLink({
  uri: 'https://zeigdeinprodukt.de/backend/graphql',
  // uri: 'https://dev-zeig-dein-produkt-9.pantheonsite.io/graphql',
  headers: {
    authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjUxNTZiNTY3YzA2NzIxYjg0ZWQ5ZDZjOTdiYjhmMGZhNTNlNDg4ZTgwMDE5ZjU2MjU2MmNkMjdmYmZjOWE2NGVlZGJlNWE0MTVjYTg0YjM0In0.eyJhdWQiOiI5MTBlODgwOC00ZjlmLTQ1Y2ItOGM2Zi04ODRmODAxNGNkNzIiLCJqdGkiOiI1MTU2YjU2N2MwNjcyMWI4NGVkOWQ2Yzk3YmI4ZjBmYTUzZTQ4OGU4MDAxOWY1NjI1NjJjZDI3ZmJmYzlhNjRlZWRiZTVhNDE1Y2E4NGIzNCIsImlhdCI6MTczNzcxNTAxNiwibmJmIjoxNzM3NzE1MDE2LCJleHAiOjE3NjkyNTEwMTUsInN1YiI6IjY0Iiwic2NvcGVzIjpbImF1dGhlbnRpY2F0ZWQiLCJncmFwaHFsIl19.W0yDuOcIHxTvp-x_2EuzaNIX8qZoXPSsX8ZH4e6KL4i0PIATdABAgoojBBl7j21x8wCJoDO1DlwjMNRLHqL2s20rgIDXHxP67stc7tHXMCgwUA3jHEAmQa-kI2BjELMLg48TyvzbR6qRAKD60bsz9TYtKBaqOWp8br7cPntuF7O9WIN4_39yGRPt7RpeL3LoYSKXdKPLkOICgeEnLAztK5SUmd98x8qXrdZF_ASUMlx43thN-_l6xp9UXLoQHfCuWSj01X_yum4ICBzzYSwoeBOHlNJ6ANO70Tx528fJNujqVn9wcwyz20lEkScrAADtTrcPm4-2i0yRjb-BuZbQp7gwrOb8lhawnmOhXVg5-1pTqO3oNOC7R5DrIPdLg1drYyXz69UWZtPuA7i9PQGaw_h6hEe0xS5g6i5OYfQZcrvssBASeXuJs-zgaUGs-neFtsyeoU1FUX2ucNeenxmIs7czOJ5EZppblqpBx8au5ejew8VlHhROiqrVCS7KqAYf4y6JQG_bFEaQtWnCCRB9peyOt_fY6FEFoZcaYWPCJ16vuqHqmGxoYtzg0bEee7qZ_tDh0-GBL2tq60Z82IqNWj9eTa8gPIhBH8BgvD5J1ANJXA6Mom9PpRgoTM8abb0SeTkGLZspO5RDVRciidbEjBsT9WjDzIxY8FrpOkipd64`
  }
});

const middlewareLink = new ApolloLink((operation, forward) => {
  operation.setContext({});
  return forward(operation);
});

const link = middlewareLink.concat(httpLink);

const apolloClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache({fragmentMatcher}),
  defaultHttpLink: false,
});

Vue.config.productionTip = false;

Vue.use(VueApollo);
Vue.use(VueLazyload);
Vue.use(Vue2TouchEvents);
Vue.use(VueCookies);
Vue.use(VueMatomo, {
  host: 'https://zeigdeinprodukt.de/matomo',
  siteId: 1,
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: true,
  debug: false,
});

// Disable VueWarn printing
Vue.config.warnHandler = function(msg, vm, trace) {};

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  apolloProvider,
  router,
  i18n,
  components: { App },
  template: '<App/>'
});
